import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'

import {
  ICreateDeclineReasonsDto,
  IMessageResponseDto,
  IDeclineReasonsRespDto,
  IUpdateDeclineReasonsDto,
  IDeclineReasonsBaseWithId,
} from 'src/types'

class DeclineReasonsService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getDeclineReasons(params?: {}) {
    return this.get<IDeclineReasonsRespDto>('decline-reasons/', { params })
  }

  getDeclineReasonsOptions() {
    return this.get<IDeclineReasonsBaseWithId[]>('decline-reasons/options', {})
  }

  createDeclineReason(dto: ICreateDeclineReasonsDto) {
    return this.post<IMessageResponseDto, ICreateDeclineReasonsDto>('decline-reasons/', dto)
  }

  updateDeclineReason(id: string, dto: IUpdateDeclineReasonsDto) {
    return this.put<IMessageResponseDto, IUpdateDeclineReasonsDto>(`decline-reasons/${id}`, dto)
  }

  removeDeclineReasons(ids: string[]) {
    return this.delete<IMessageResponseDto>(`decline-reasons/`, { data: { ids } })
  }
}

export const declineReasonsService = new DeclineReasonsService()
